import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function ArticleIntroduction() {
  const [affiliateOpen, setAffiliateOpen] = useState(false);
  const [rankingsOpen, setRankingsOpen] = useState(false);
  return <section className="bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-4 py-4 md:py-12">

        <div className="flex flex-col gap-8 items-start">

          <div className="w-full">
            <div className="space-y-5 text-sm md:text-base leading-relaxed text-foreground/80">
              <p className="!text-xl !text-[rgba(75,79,88,1)] !font-normal !font-serif"><b>We started with 23 teeth whitening products.</b> Our team conducted an independent 180-day evaluation of the market's leading solutions, ranging from strips and powders to professional-grade LED kits. Each product underwent a rigorous 30-day comprehensive test cycle to objectively measure shade improvement, long-term result retention, and the actual cost-to-value ratio.</p>

              <p className="!bg-transparent !text-xl !text-[rgba(75,79,88,1)] !font-serif">
                The majority fell short. A few were decent.{" "}
                <strong className="text-foreground font-semibold !text-xl">
                  One absolutely destroyed the competition.
                </strong>
              </p>

              <p className="!text-xl !text-[rgba(75,79,88,1)] !font-serif">
                The top five are ranked below. If you want the short version:{" "}
                <strong className="text-foreground font-semibold">
                  the #1 product whitened teeth faster, delivered more dramatic results, and cost less per month than anything else we tested.
                </strong>{" "}
                It wasn't close. Several of our testers saw visible whitening after a single use, and results held for months after they stopped.
              </p>

              <p className="!not-italic !font-medium !text-[rgba(75,79,88,1)] !font-serif">
                Scroll down to see the full rankings and find out which one is actually worth your money.
              </p>

              <div className="pt-4">
                

                <Card className="rounded-lg border-2 border-foreground shadow-md bg-card">
                  <CardContent className="p-6 md:p-8">
                    <h3 className="text-lg font-bold leading-snug mb-4 !text-[rgba(75,79,88,1)] !font-serif">
                      Important Note About Brands We Compare
                    </h3>
                    <p className="text-sm leading-relaxed !text-[rgba(75,79,88,1)] !font-serif">
                      We're{" "}
                      <strong className="text-foreground font-semibold">
                        not sponsored or endorsed by any of the brands
                      </strong>{" "}
                      featured in this comparison. All trademarks and product names belong to their respective owners and are used solely for the purpose of accurate product identification and comparison.
                    </p>
                  </CardContent>
                </Card>
              </div>
            </div>

            <Separator className="my-10 bg-border" />

            <div className="flex flex-col sm:flex-row gap-4">
              <Button variant="ghost" onClick={() => {
              setAffiliateOpen(!affiliateOpen);
              setRankingsOpen(false);
            }} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 group h-auto p-0 bg-transparent hover:bg-transparent">
                <span className="w-5 h-5 rounded-lg border border-current flex items-center justify-center text-xs font-bold group-hover:bg-foreground group-hover:text-background transition-all duration-200">i</span>
                <span className="underline underline-offset-2 decoration-dashed">Affiliate Disclosure</span>
              </Button>

              <Button variant="ghost" onClick={() => {
              setRankingsOpen(!rankingsOpen);
              setAffiliateOpen(false);
            }} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 group h-auto p-0 bg-transparent hover:bg-transparent">
                <span className="w-5 h-5 rounded-lg border border-current flex items-center justify-center text-xs font-bold group-hover:bg-foreground group-hover:text-background transition-all duration-200">i</span>
                <span className="underline underline-offset-2 decoration-dashed">About Our Rankings</span>
              </Button>
            </div>

            {affiliateOpen && <Card className="mt-4 rounded-lg border-l-4 border-l-foreground border-t-0 border-r-0 border-b-0 bg-muted/40 shadow-md">
                <CardContent className="pt-5 pb-5">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="text-xs leading-relaxed text-muted-foreground">
                        This site is free to use. We make money through advertising and affiliate partnerships with some of the companies featured here, which may influence which products we choose to review. However, affiliate relationships never affect our rankings, ratings, or editorial opinions. Being listed here doesn't mean we endorse a product, and we don't cover every option on the market. Prices and availability can change at any time. We do our best to keep everything accurate, but we can't guarantee it. For full details, see our Terms of Use.
                      </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => setAffiliateOpen(false)} className="text-muted-foreground hover:text-foreground text-xs shrink-0 font-medium transition-colors h-auto p-0 bg-transparent hover:bg-transparent">
                      Close
                    </Button>
                  </div>
                </CardContent>
              </Card>}

            {rankingsOpen && <Card className="mt-4 rounded-lg border-l-4 border-l-foreground border-t-0 border-r-0 border-b-0 bg-muted/40 shadow-md">
                <CardContent className="pt-5 pb-5">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="text-xs leading-relaxed text-muted-foreground">
                        We rate products based on how well they actually perform, how easy they are to use, how they're priced compared to similar products, and what verified buyers are saying about them. Our editors test each product and assign scores based on their findings. We also look at customer feedback trends to make sure our recommendations hold up in the real world.
                      </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => setRankingsOpen(false)} className="text-muted-foreground hover:text-foreground text-xs shrink-0 font-medium transition-colors h-auto p-0 bg-transparent hover:bg-transparent">
                      Close
                    </Button>
                  </div>
                </CardContent>
              </Card>}
          </div>

        </div>
      </div>
    </section>;
}